import Base from './base'

export default class Logger extends Base {
  logError(data: object) {
    return this.apiClient.post('log-error', data)
  }
}
